import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import CircledExclamationmarkIcon from 'icons/CircledExclamationmark.icon';
import { LeadStages } from 'models/Lead';
import {
  getIsArrayEmpty,
  getResolveUrl,
  getSellingPortfolio,
  isSingleElementArray,
} from 'utils';

import './ReleaseOrderShareNote.styles.scss';

type ReleaseOrderShareNoteProps = {
  className?: string;
  // Stages whose order holds any of the selected files.
  steps: LeadStages[];
  isSingleFile: boolean;
  stageCopies: Record<LeadStages, string>;
};

const ReleaseOrderShareNote: React.FC<ReleaseOrderShareNoteProps> = (props) => {
  const { className, steps, isSingleFile, stageCopies } = props;

  const {
    dataRoom: { dealRoomId },
  } = useContext(DataRoomContext);

  const { t } = useTranslation();

  if (getIsArrayEmpty(steps)) return null;

  const singleStep = isSingleElementArray(steps) ? steps[0] : undefined;

  // The Data Room is served on its own origin, so the link leaves it.
  const automationUrl = getResolveUrl(
    `${getSellingPortfolio(dealRoomId, 'settings')}${
      singleStep ? `/${singleStep}` : ''
    }`,
  );

  return (
    <div className={classNames('release-order-share-note', className)}>
      <CircledExclamationmarkIcon />
      <p>
        {isSingleFile && singleStep
          ? t('fileInStageOrderNote', { stage: stageCopies[singleStep] })
          : t('filesInReleaseOrderNote')}
        <a href={automationUrl}>{t('openAutomation')}</a>
      </p>
    </div>
  );
};

export default ReleaseOrderShareNote;
